import React, { useEffect } from 'react'
import successImg from "../../Assets/images/cancel-svgrepo-com.svg"
import { useNavigate } from 'react-router-dom'
import useMakeRequest from '../../utils/ApiHelper'
import { useLocation } from 'react-router-dom'
import { ApiConstants } from '../../constants/ApiConstants'
import { LanguageConstants } from '../../constants/LanguageConstants'

function Cancel() {
  const PaymentStatus = useMakeRequest()
    const navigate  = useNavigate()
    const loaction = useLocation()
    const ID = loaction?.search?.split('?success=')

   useEffect(()=>{
    if(ID.length  > 0){
    const payload ={
      type:'web',
      payment_type:0,
      paymeny_status:'cancel',
      payment_id:ID[1]
      }
      // PaymentStatus.makeRequest({ payload, url: ApiConstants?.OrderStatus, toastStatus: true })
    }
    },[])

    const handleNavigateHome =()=>{
      navigate('/')
    }
  return (
    <div className="modal fade com-modal short-modal success-modal text-center show" id="successModal" aria-labelledby="successModalLabel" aria-hidden="true" style={{ display: "block" }}>
    <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body py-0">
                        <img className="success-img" src={successImg} alt="" style={{width:'100px'}} />
                       <div className="success-heading">{LanguageConstants?.Payment_Cancelled}</div>
                       <div className="px-5 mb-4">
                            <p>{LanguageConstants?.Payment_Cancelled1}</p>
                            <p>{LanguageConstants?.Payment_Cancelled2}</p>
                       </div>
                    </div>
                    <div className="modal-footer">
                        <button type="submit" className="round-btn m-0 w-100" onClick={()=>handleNavigateHome()} >Go to Home</button>
                    </div>
                </div>
            </div>
  </div>
  )
}

export default Cancel